// Naturkammer Cart-Modules — Timer & Reset-Logik
(function() {
  function initCartTimer() {
    const timers = document.querySelectorAll('[data-cart-timer]');
    if (!timers.length) return;

    timers.forEach(el => {
      const wrap = el.closest('.nk-cm-timer');
      if (!wrap || wrap.dataset.timerInit === '1') return;
      wrap.dataset.timerInit = '1';

      const minutes = parseInt(wrap.dataset.duration, 10) || 10;
      let endTs;
      try {
        const stored = sessionStorage.getItem('nk_cart_timer_end');
        if (stored) {
          const t = parseInt(stored, 10);
          if (!isNaN(t) && t > Date.now()) {
            endTs = t;
          }
        }
      } catch(e) {}

      if (!endTs) {
        endTs = Date.now() + minutes * 60 * 1000;
        try { sessionStorage.setItem('nk_cart_timer_end', String(endTs)); } catch(e) {}
      }

      function pad(n) { return n < 10 ? '0' + n : '' + n; }

      function tick() {
        let diff = endTs - Date.now();
        if (diff <= 0) {
          // Reset auf neue Runde
          endTs = Date.now() + minutes * 60 * 1000;
          try { sessionStorage.setItem('nk_cart_timer_end', String(endTs)); } catch(e) {}
          diff = endTs - Date.now();
        }
        const totalSec = Math.floor(diff / 1000);
        const min = Math.floor(totalSec / 60);
        const sec = totalSec % 60;
        el.textContent = pad(min) + ':' + pad(sec);
      }

      tick();
      const interval = setInterval(() => {
        if (!document.body.contains(el)) {
          clearInterval(interval);
          return;
        }
        tick();
      }, 1000);
    });
  }

  // ============================================================
  // Cross-Sell-Slider (Karussell): Pfeile, Dots, Peek-Wischen
  // Robust gegen das Re-Rendering (morph) des Cart-Drawers:
  // bei jedem Aufruf werden ALLE Slider frisch verdrahtet, alte
  // Listener/Observer pro Track werden vorher sauber getrennt.
  // ============================================================

  // Map<trackElement, {io: IntersectionObserver, ac: AbortController}>
  var nkXssWired = new WeakMap();

  function initCartCrossSellSlider() {
    var sliders = document.querySelectorAll('[data-nk-xss]');
    sliders.forEach(function (slider) {
      // Markieren, damit der MutationObserver nicht bei jeder Mutation feuert.
      slider.setAttribute('data-xss-ready', '1');

      var track = slider.querySelector('[data-nk-xss-track]');
      if (!track) return;

      var slides = Array.prototype.slice.call(slider.querySelectorAll('[data-nk-xss-slide]'));
      var prev = slider.querySelector('[data-nk-xss-prev]');
      var next = slider.querySelector('[data-nk-xss-next]');
      var dots = Array.prototype.slice.call(slider.querySelectorAll('[data-nk-xss-dot]'));

      // Alte Verdrahtung dieses Tracks trennen (falls Knoten wiederverwendet wurde)
      var existing = nkXssWired.get(track);
      var isFreshTrack = !existing;
      if (existing) {
        if (existing.io) existing.io.disconnect();
        if (existing.ro) existing.ro.disconnect();
        if (existing.ac) existing.ac.abort();
      }

      // Eine Karte (oder weniger): nichts zu steuern
      if (slides.length <= 1) {
        nkXssWired.set(track, {});
        return;
      }

      var ac = new AbortController();
      var signal = ac.signal;

      // Schrittweite = Abstand zwischen erstem und zweitem Slide (inkl. Gap)
      function getStep() {
        if (slides.length > 1) {
          var d = slides[1].offsetLeft - slides[0].offsetLeft;
          if (d > 0) return d;
        }
        return slides[0] ? slides[0].getBoundingClientRect().width : track.clientWidth;
      }

      function updateArrows() {
        if (!prev || !next) return;
        // Solange der Track keine echte Breite hat (Drawer noch geschlossen),
        // Pfeile NICHT deaktivieren — sonst bleibt "Weiter" fälschlich disabled,
        // bis ein Scroll-Event (z.B. Dot-Klick) neu misst.
        if (track.clientWidth === 0) {
          prev.disabled = false;
          next.disabled = false;
          return;
        }
        var atStart = track.scrollLeft <= 2;
        var atEnd = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
        prev.disabled = atStart;
        next.disabled = atEnd;
      }

      if (prev) {
        prev.addEventListener('click', function () {
          track.scrollBy({ left: -getStep(), behavior: 'smooth' });
        }, { signal: signal });
      }
      if (next) {
        next.addEventListener('click', function () {
          track.scrollBy({ left: getStep(), behavior: 'smooth' });
        }, { signal: signal });
      }

      // Dot-Klick -> zu Slide scrollen
      dots.forEach(function (dot) {
        dot.addEventListener('click', function () {
          var idx = parseInt(dot.getAttribute('data-index'), 10) || 0;
          if (slides[idx]) {
            track.scrollTo({ left: slides[idx].offsetLeft - track.offsetLeft, behavior: 'smooth' });
          }
        }, { signal: signal });
      });

      // Aktiven Dot via IntersectionObserver bestimmen (robust bei Peek)
      var io = null;
      if ('IntersectionObserver' in window) {
        io = new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              if (!entry.isIntersecting) return;
              var idx = slides.indexOf(entry.target);
              if (idx < 0) return;
              dots.forEach(function (d, i) {
                if (i === idx) d.classList.add('is-active');
                else d.classList.remove('is-active');
              });
            });
          },
          { root: track, threshold: 0.6 }
        );
        slides.forEach(function (s) {
          io.observe(s);
        });
      }

      track.addEventListener('scroll', updateArrows, { passive: true, signal: signal });

      // ResizeObserver: Sobald der Track seine echte Breite bekommt (Drawer
      // öffnet sich), Pfeil-Status neu berechnen. Behebt den Desktop-Bug, dass
      // der "Weiter"-Pfeil bis zum ersten Dot-Klick deaktiviert blieb.
      var ro = null;
      if ('ResizeObserver' in window) {
        ro = new ResizeObserver(function () {
          updateArrows();
        });
        ro.observe(track);
      }

      // Scroll-Position NUR bei frisch ge-morphtem/neuem Track zurücksetzen,
      // damit ein Re-Init (z.B. durch den Sekunden-Timer) nicht mitten im
      // Wischen/Pfeil-Klick auf das erste Produkt zurückspringt.
      if (isFreshTrack) {
        track.scrollLeft = 0;
      }
      updateArrows();

      nkXssWired.set(track, { io: io, ac: ac, ro: ro });
    });
  }

  function initCartModules() {
    initCartTimer();
    initCartCrossSellSlider();
  }

  // Init beim Laden
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCartModules);
  } else {
    initCartModules();
  }

  // Re-Init wenn Cart-Drawer öffnet oder Cart aktualisiert wird
  document.addEventListener('cart:update', initCartModules);
  document.addEventListener('cart:add', initCartModules);

  // MutationObserver — fängt dynamisch nachgeladene Cart-Inhalte ab.
  // Guard auf NICHT-initialisierte Elemente, damit der Observer nicht bei
  // jeder Mutation feuert. Der Slider markiert sich mit data-xss-ready="1";
  // ein frisch ge-morphter Slider hat das Attribut nicht -> wird neu verdrahtet.
  const observer = new MutationObserver(() => {
    // Guard auf den Timer-WRAPPER (dort sitzt data-timer-init), NICHT auf das
    // data-cart-timer-Element selbst — dessen Text ändert sich jede Sekunde und
    // würde sonst bei jeder Sekunde ein Re-Init auslösen (Slider sprang zurück).
    if (
      document.querySelector('.nk-cm-timer:not([data-timer-init="1"])') ||
      document.querySelector('[data-nk-xss]:not([data-xss-ready="1"])')
    ) {
      initCartModules();
    }
  });
  observer.observe(document.body, { childList: true, subtree: true });
})();
